import {menuSize} from "../@signals";
import {MENU_SIZE} from "../@constants";
import {useResponsive} from "./index";


export default function useApp() {
    const isDesktop = useResponsive('up', 'lg')

    return {
        isMini: isDesktop ? menuSize.value === MENU_SIZE.MINI : false,
        isDesktop: isDesktop
    }
}